import React from 'react';

const Italy = (props) => (
  <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_3127_46391)">
      <rect width="28" height="20" rx="3" fill="white" />
      <path fillRule="evenodd" clipRule="evenodd" d="M18.6665 0H27.9998V20H18.6665V0Z" fill="#F93939" />
      <path fillRule="evenodd" clipRule="evenodd" d="M0 0H9.33333V20H0V0Z" fill="#249F58" />
    </g>
    <rect x="0.25" y="0.25" width="27.5" height="19.5" rx="2.75" stroke="#AEAEAE" strokeWidth="0.5" />
    <defs>
      <clipPath id="clip0_3127_46391">
        <rect width="28" height="20" rx="3" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Italy;
